<template>
  <div>
    <set-guest-master />
    <set-guest-off v-if="!on" />
    <div v-else class="ss-g" :class="ctl.isPhone ? 'ss-g1' : 'ss-g2'">
      <div class="ss-gm">
        <set-card id="nacin" :title="$t('settings_shell.offer.pickup')" :desc="$t('settings_shell.offer.pickup_d')">
          <div class="ss-opts">
            <set-option path="guest.meal_in_restaurant" icon="mdi-silverware-fork-knife" :title="$t('settings_shell.fields.meal_in_restaurant')" :desc="$t('settings_shell.offer.meal_in_restaurant_d')" />
            <set-option path="guest.personal_takeover" icon="mdi-shopping-outline" :title="$t('settings_shell.fields.personal_takeover')" :desc="$t('settings_shell.offer.personal_takeover_d')" />
            <set-option path="guest.restoran_delivery" icon="mdi-truck-delivery-outline" :title="$t('settings_shell.fields.restaurant_delivery')" :desc="$t('settings_shell.offer.delivery_d')">
              <div class="ss-frow-g">
                <set-field path="guest.delivery_price" :label="$t('delivery_price')" :suffix="ctl.currency" mode="decimal" />
                <set-field path="guest.minimal_price" :label="$t('minimal_price')" :suffix="ctl.currency" mode="decimal" />
              </div>
            </set-option>
            <set-option path="guest.post_delivery" icon="mdi-email-outline" :title="$t('settings_shell.fields.post_delivery')" :desc="$t('settings_shell.offer.post_d')">
              <div class="ss-frow-g">
                <set-field path="guest.post_price" :label="$t('delivery_price_post')" :suffix="ctl.currency" mode="decimal" />
                <set-field path="guest.post_minimal_price" :label="$t('minimal_price_post')" :suffix="ctl.currency" mode="decimal" />
              </div>
            </set-option>
          </div>
          <set-field path="guest.post_description" multiline :label="$t('post_description')" :placeholder="$t('settings_shell.offer.post_description_ph')" />
        </set-card>
      </div>
      <aside class="ss-gs ss-gs--n">
        <set-card id="prijem" :title="$t('settings_shell.offer.orders_card')">
          <set-switch path="receiving_orders" :title="$t('receiving_orders')" :desc="$t('settings_shell.offer.receiving_d')" />
          <set-switch path="can_order_off" :title="$t('settings_shell.offer.order_off')" :desc="$t('restaurant_order_off')" />
          <p v-if="!ctl.val('receiving_orders')" class="ss-note ui-banner ui-banner--warn">
            <v-icon size="16">mdi-alert-outline</v-icon>
            <span>{{ $t("settings_shell.offer.receiving_warn") }}</span>
          </p>
        </set-card>
        <set-card id="komentari" :title="$t('comments')">
          <set-switch path="comments_guest" :title="$t('settings_shell.offer.comments_guests')" :desc="$t('comments_guest')" />
          <set-switch path="comments_restaurant" :title="$t('settings_shell.offer.comments_restaurants')" :desc="$t('comments_restaurant')" />
        </set-card>
      </aside>
    </div>
  </div>
</template>

<script>
import SetCard from "../parts/SetCard.vue";
import SetSwitch from "../parts/SetSwitch.vue";
import SetOption from "../parts/SetOption.vue";
import SetField from "../parts/SetField.vue";
import SetGuestMaster from "../parts/SetGuestMaster.vue";
import SetGuestOff from "../parts/SetGuestOff.vue";

/** Gosti › Ponuda: način preuzimanja i dostave, prijem narudžbi i komentari. */
export default {
  name: "ScreenOffer",
  components: { SetCard, SetSwitch, SetOption, SetField, SetGuestMaster, SetGuestOff },
  inject: { ctl: "settingsCtl" },
  computed: {
    on() {
      return Boolean(this.ctl.val("lice_bez_ugovora"));
    },
  },
};
</script>
